
import React from 'react';

export const AppSpecificTab = () => {
  return (
    <div className="space-y-4">
      <p className="text-muted-foreground">
        Configure settings specific to this application.
      </p>
      
      <div className="p-4 bg-warning/10 border border-warning/20 rounded text-sm text-warning">
        Application-specific settings will be implemented in a future update.
      </div>
    </div>
  );
};
